import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

export default ({ ...props }) => <Input {...props} />

export const inputStyle = {
  fontSize: "0.9rem",
  padding: "0.8rem",
  marginBottom: "0.5rem",
  borderRadius: 5,
  border: `1px solid ${style.colors.whiteSmoke}`,
}

const Input = glamorous.input(
  {
    ...inputStyle,
  },
  ({ inline, type }) => ({
    width: inline && "75%",
    border: inline && `1px solid ${style.colors.darkerGray}`,
    marginRight: "1rem",
    [style.size.mobile]: inline && {
      width: "100%",
    },
  })
)



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/FieldParts/Input/index.js